import React  from 'react';
import DateComponentProto from './date-proto';


export default function renderDateInView(id, props) {
    return <DateComponentProto renderMode="view" id={id} {...props} showDeleteButton={true}/>;
}